<template>
	<section id="video-section" class="wip-video" :style="`background-image: url('${ videoData.background_url }')`">
		<h3 class="wip-video__heading">
			{{ videoData.title | stripTags }}
		</h3>
		<div class="wip-video__container">
			<youtube-video
				:video-id="videoId"
				:autoplay="true"
				:autoplay-offset="300"
			/>
		</div>
	</section>
</template>

<script>
import YoutubeVideo from "@c/generals/youtube-video";

export default {
	name: "VideoSection",
	components: {
		YoutubeVideo
	},
	props: {
		videoData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			videoId: "tSDpawYkqAo"
		};
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.wip-video {
    padding: 65px 0;
    background-size: cover;

    @media (max-width: 991px) {
        padding: 45px 15px;
    }

    &__heading {
        font-size: 36px;
        text-transform: uppercase;
        text-align: center;
        margin-top: 0;
        margin-bottom: 25px;
        color: $white;

        @media (max-width: 991px) {
            text-align: left;
        }
    }

    &__container {
        max-width: 850px;
        height: 480px;
        margin: 0 auto;

        @media (max-width: 580px) {
            height: 185px;
        }
    }
}
</style>